import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "three-dots",
  "use": "three-dots-usage",
  "viewBox": "0 0 14 3",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 3\" id=\"three-dots\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.942 2.475a1.124 1.124 0 100-2.248 1.124 1.124 0 000 2.248zM12.057 2.475a1.124 1.124 0 100-2.248 1.124 1.124 0 000 2.248zM7 2.475A1.124 1.124 0 107 .227a1.124 1.124 0 000 2.248z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol